import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// App.css is typically imported in App.js or index.js, so styles should be available globally.
// If not, uncomment the line below:
// import '../App.css';

const AccessDeniedPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Console logs are kept for debugging if needed, can be removed for production
    console.log(
      '[AccessDeniedPage] useEffect triggered. Setting 5-second timer.',
    );
    const timer = setTimeout(() => {
      console.log('[AccessDeniedPage] 5-second timer elapsed. Navigating to /');
      navigate('/');
    }, 5000);

    return () => {
      console.log('[AccessDeniedPage] Cleanup function ran. Clearing timer.');
      clearTimeout(timer);
    };
  }, [navigate]);

  console.log('[AccessDeniedPage] Component rendered.');

  return (
    <div className="access-denied-page">
      <div className="access-denied-container">
        <h2>Giriş Reddedildi</h2>
        <div className="error-text">
          E-posta adresiniz sisteme kayıtlı değil veya erişim yetkiniz
          bulunmamaktadır. Lütfen yöneticinizle iletişime geçin.
        </div>
        <button
          className="access-denied-button"
          onClick={() => {
            console.log(
              '[AccessDeniedPage] Manual redirect button clicked. Navigating to /',
            );
            navigate('/');
          }}
        >
          Giriş Sayfasına Dön
        </button>
      </div>
    </div>
  );
};

export default AccessDeniedPage;
